import script from "./Oferta2.vue?vue&type=script&setup=true&lang=js"
export * from "./Oferta2.vue?vue&type=script&setup=true&lang=js"

import "./Oferta2.vue?vue&type=style&index=0&id=86b2401e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86b2401e"]])

export default __exports__